/* eslint-disable react-hooks/exhaustive-deps */
import { Button, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import React, { FC } from 'react';
import { COLORS } from '../../constants/constants';
import Popup from '../Popup/Popup';
import { IconArrowDown, IconArrowUp } from '../../images';

interface Option {
    label: string;
    value?: string;
    onClick?: () => void;
    tooltip?: any;
}

interface CustomSelectProps {
    options: Array<Option>;
    name: string;
    icon?: any;
}

const CustomSelect: FC<CustomSelectProps> = ({ options, name, icon }) => {
    return (
        <Popup
            actionElement={(handleOpen, anchorReference, open) => (
                <Button
                    ref={anchorReference}
                    color="tetriary"
                    sx={{
                        backgroundColor: open ? COLORS.BRAND_LIGHTEST : null,
                    }}
                    onClick={(e) => {
                        handleOpen();
                    }}
                >
                    {icon}
                    <Typography
                        variant="s16w500"
                        className={open ? 'color-b' : 'color-b'}
                        sx={{
                            ml: icon ? 0.5 : 0,
                            mr: 1.5,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {name}
                    </Typography>
                    {open ? (
                        <IconArrowUp className="fill-b" />
                    ) : (
                        <IconArrowDown className={options.length ? 'fill-b' : 'fill-bd'} />
                    )}
                </Button>
            )}
            contentElement={(handleClose) => (
                <List sx={{ m: 1 }}>
                    {options.map((option, index) => (
                        <ListItem
                            key={index}
                            disablePadding
                            onClick={(e) => {
                                handleClose();
                                e.stopPropagation();
                                option.onClick?.();
                            }}
                            sx={{ pt: index === 0 ? 1 : 0, pb: index === options.length - 1 ? 1 : 0 }}
                        >
                            <ListItemButton
                                sx={{ height: '30px', borderLeft: 'unset !important', p: 0 }}
                                className="background-color-hover-mho"
                            >
                                <ListItemText sx={{ pr: 1, width: 156, px: 1 }} primary={option.label} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            )}
        />
    );
};

export default CustomSelect;
